import * as React from 'react';

const MapSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="map_svg__eds-icon--map_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 3c-1.1 0-2 .9-2 2H2v16h17.8c1.1 0 2.1-.9 2.1-2V5c.1-1.1-.8-2-1.9-2zm-.2 17H3V6h15v13h1c0-.6.4-1 1-1 .5 0 .9.4 1 .9-.1.6-.6 1.1-1.2 1.1zm1.2-2.7c-.3-.2-.6-.3-1-.3s-.7.1-1 .3V5c0-.6.4-1 1-1s1 .4 1 1v12.3z"
        />
        <path
            id="map_svg__eds-icon--map_cross"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.8 12.7l.7-.7-1.1-1 1.1-1-.7-.7-1.1 1-1-1-.7.7 1 1-1 1 .7.7 1-1z"
        />
        <path
            id="map_svg__eds-icon--map_dash_3_"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 10h2v1h-2z"
        />
        <path
            id="map_svg__eds-icon--map_dash_2_"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15 12h1v2h-1z"
        />
        <path
            id="map_svg__eds-icon--map_dash_1_"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 15h2v1h-2z"
        />
        <path
            id="map_svg__eds-icon--map_dash"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 15h2v1H8z"
        />
    </svg>
);

MapSvg.displayName = 'MapSvg';
export default MapSvg;
